import { useEffect } from 'react'

import { getCsrfCookieApi } from '@/api/common'
import useToken from './useToken'

export default function useGetCsrfToken() {
  const { token } = useToken()
  const getData = () => {
    getCsrfCookieApi(token)
  }

  useEffect(() => {
    getData()
  }, [])
}
